import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import { loadPost } from 'redux/Post/actions';
import { loadPosts } from 'redux/Posts/actions';
import { scrollToTop, ssrHandler } from 'utils';

import NewsPostTemplate from './NewsPostTemplate';

function getPathname(pathname) {
  const params = pathname.split('/').filter(Boolean).slice(0, 2);
  return `/${params.join('/')}/`;
}

class NewsPost extends PureComponent {
  componentWillReceiveProps(nextProps) {
    if (this.props.params.id !== nextProps.params.id) {
      scrollToTop();
    }
  }

  render() {
    return (
      <NewsPostTemplate
        post={this.props.post}
        posts={this.props.posts}
        relevant={this.props.relevant}
        layout={this.props.layout}
        pathname={this.props.pathname}
      />
    );
  }
}

NewsPost.propTypes = {
  layout: PropTypes.oneOf(['mobile', 'tablet', 'desktop']),
  post: PropTypes.shape({
    dateDisplay: PropTypes.string,
    titleImage: PropTypes.string,
    title: PropTypes.string,
    companyLogo: PropTypes.string,
    companyText: PropTypes.string,
    content: PropTypes.object,
    tags: PropTypes.arrayOf(PropTypes.object)
  }),
  posts: PropTypes.shape({
    primaryPost: PropTypes.object,
    secondaryPost: PropTypes.object,
    results: PropTypes.arrayOf(PropTypes.object),
    isFetching: PropTypes.bool,
    fetchingErrors: PropTypes.object
  }),
  relevant: PropTypes.arrayOf(PropTypes.object)
};

const mapStateToProps = (state, props) => ({
  layout: state.app.layout,
  post: state.post.result,
  posts: state.posts,
  relevant: state.posts.results.slice(0, 3),
  pathname: getPathname(props.location.pathname)
});

function loadPostData(store, nextState, replace, callback) {
  const { postId } = nextState.params;

  const pathname = getPathname(nextState.location.pathname);
  const query = nextState.location.query;
  const preview = query && 'preview' in query;
  const category = pages[pathname];

  const actions = [
    loadPost(postId, preview),
    loadPosts(category)
  ];

  ssrHandler(store.dispatch, actions, callback);
}

const createRoute = (store, pathname) => ({
  path: `${pathname}:postId`,
  component: connect(mapStateToProps)(NewsPost),
  onEnter: loadPostData.bind(null, store)
});

const pages = {
  '/analyze/actually/': 'analyze',
  '/we/news/': 'news'
};

export default store => Object.keys(pages).map(createRoute.bind(null, store));



// WEBPACK FOOTER //
// ./src/components/NewsPost/index.js